import { render, staticRenderFns } from "./SendLinkFnolViaSmsPage.vue?vue&type=template&id=557493c8&"
import script from "./SendLinkFnolViaSmsPage.vue?vue&type=script&lang=js&"
export * from "./SendLinkFnolViaSmsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports